const roleConstants = {
    ROLE_NAME_AGENT : 'ROLE_AGENT',

    ROLE_NAME_AGENCY_USER : 'ROLE_AGENCY_USER',

    ROLE_NAME_ADMIN : 'ROLE_ADMIN',

    ROLE_NAME_AGENCY_ADMIN : 'ROLE_AGENCY_ADMIN',

    ROLE_NAME_USER_ADMIN : 'ROLE_USER_ADMIN',

    ROLE_NAME_USER_ADMIN_2 : 'ROLE_USER_ADMIN_2',

    ROLE_NAME_CARRIER_ADMIN_1 : 'ROLE_CARRIER_ADMIN_1',

    ROLE_NAME_CARRIER_ADMIN_2 : 'ROLE_CARRIER_ADMIN_2',

    ROLE_NAME_OPERATOR : 'ROLE_OPERATOR',

    ROLE_USER_GROUP_ADMIN : 'ROLE_USER_GROUP_ADMIN',

    ROLE_NAME_UNDERWRITER : 'ROLE_UNDERWRITER',

    ROLE_NAME_UNDERWRITER_MANAGER : 'ROLE_UNDERWRITER_MANAGER',

    ROLE_NAME_UNDERWRITER_TECH : 'ROLE_UNDERWRITER_TECH',

    ROLE_NAME_UNDERWRITER_ASSISTANT : 'ROLE_UNDERWRITER_ASSISTANT',

    ROLE_NAME_UNDERWRITER_EXAMINER : 'ROLE_UNDERWRITER_EXAMINER',

    ROLE_NAME_MGA_UNDERWRITER : 'ROLE_MGA_UNDERWRITER',

    ROLE_NAME_MGA_UNDERWRITER_ASSISTANT : 'ROLE_MGA_UNDERWRITER_ASSISTANT',

    ROLE_NAME_SERVICE : 'ROLE_SERVICE',

    ROLE_NAME_SERVICE_SAFETY : 'ROLE_SERVICE_SAFETY',

    ROLE_NAME_SERVICE_CLAIMS : 'ROLE_SERVICE_CLAIMS',

    ROLE_NAME_SERVICE_MARKETING : 'ROLE_SERVICE_MARKETING',

    ROLE_NAME_SERVICE_ACCOUNTING : 'ROLE_SERVICE_ACCOUNTING',

    ROLE_NAME_SERVICE_PREMIUM_AUDITOR : 'ROLE_SERVICE_PREMIUM_AUDITOR',

    ROLE_NAME_SERVICE_DOI_AUDITOR : 'ROLE_SERVICE_DOI_AUDITOR',

    ROLE_SUBMISSION_RESPONSIBLE_UNDERWRITER : 'ROLE_RESPONSIBLE_UNDERWRITER',

    ROLE_SUBMISSION_ASSIGNED_UNDERWRITER : 'ROLE_ASSIGNED_UNDERWRITER',

    ROLE_SUBMISSION_REFERRED_UNDERWRITER : 'ROLE_REFERRED_UNDERWRITER',

    ROLE_SUBMISSION_PRODUCER : 'ROLE_AGENT',

    ROLE_SUBMISSION_AGENCY_CONTACT : 'ROLE_AGENCY_CONTACT',

    ROLE_TASK_ASSIGNEE : 'ROLE_TASK_ASSIGNEE',

    ROLE_TASK_ASSIGNER : 'ROLE_TASK_ASSIGNER'

};

angular.module('gw-um-j2js')
    .constant('roleConstants', roleConstants);